import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
 
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;





// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries
 
// // Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyBobzigHti3XdYFP05VLGBWhZFxBkb7vhc",
//   authDomain: "cc-contact-center-dev.firebaseapp.com",
//   projectId: "cc-contact-center-dev",
//   storageBucket: "cc-contact-center-dev.appspot.com",
//   messagingSenderId: "383921619792",
//   appId: "1:383921619792:web:408fe6569d2261eddde255"
// };
 
// // Initialize Firebase
// const app = initializeApp(firebaseConfig);